class Route {
    path: string;
    title: string;
    description: string;

    constructor(path: string, title: string, description: string) {
        this.path = path;
        this.title = title;
        this.description = description
    }

    to(params: Record<string, string | number> = {}): string {
        return Object.entries(params).reduce(
            (path, [key, value]) => path.replace(`:${key}`, String(value)),
            this.path
        )
    }
}

class AppRoutes {
    AUTH = new Route('/auth', 'Auth', 'Unauthenticated shell.')
    LOGIN = new Route('/auth/login', 'Login', 'Email and password sign in.')
    VERIFY_2FA = new Route('/auth/verify-2fa-code', 'Verify 2FA', 'Enter the authenticator code to finish signing in.')
    ENABLE_2FA = new Route('/auth/enable-2fa', 'Enable 2FA', 'First time setup of the authenticator app.')
    FORGOT_PASSWORD = new Route('/auth/forgot-password', 'Forgot Password', 'Request a password reset link.')
    RESET_PASSWORD = new Route('/auth/reset-password', 'Reset Password', 'Set a new password from a reset link.')

    MAIN = new Route('/main', 'Main', 'Authenticated dashboard shell.')
    DASHBOARD = new Route('/main/dashboard', 'Dashboard', 'Landing page, open to every authenticated admin.')
    BUSINESSES = new Route('/main/businesses', 'Businesses', 'Business accounts, KYB and account requests.')
    USERS = new Route('/main/users', 'Users', 'Customer accounts, KYC and account requests.')
    TRANSACTIONS = new Route('/main/transactions', 'Transactions', 'All transactions across types.')
    DEPOSITS = new Route('/main/deposits', 'Deposits', 'Deposit transactions.')
    TRANSFERS = new Route('/main/transfers', 'Transfers', 'Transfer transactions.')
    CHARITY = new Route('/main/charity', 'Charity', 'Charities and their campaigns.')
    VIEW_DONORS = new Route('/main/charity/view-donors/:id', 'View Donors', 'Donors for a single charity.')
    PROFILE = new Route('/main/profile', 'Profile', 'Your own admin account.')
    ADMIN_USERS = new Route('/main/admin-users', 'Admin Users', 'Admin accounts, invites and access areas. Super admin only.')
    AUDIT_TRAIL = new Route('/main/audit-trail', 'Audit Trail', 'Log of admin actions.')
    FLAGGED_USERS = new Route('/main/flagged-users', 'Flagged Users', 'Sanctions screening hits awaiting review.')
    EXCHANGE_RATES = new Route('/main/exchange-rates', 'Exchange Rates', 'Currency pairs, fees and payout types.')
    BENEFICIARIES = new Route('/main/beneficiaries', 'Beneficiaries', 'Beneficiary accounts and screening status.')
    CURRENCIES = new Route('/main/currencies', 'Currencies', 'Supported currencies and their limits.')

    CATCH_ALL = new Route('*', 'Not Found', 'Anything unmatched, redirected to login.')
}

export const ROUTES = new AppRoutes()
